import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import classnames from 'classnames';
import { useScroll } from 'hooks';
import { TheNav } from 'components';
import Info from 'config/info';

import './TheHeader.scss';

export interface TheHeaderProps {
    /**
     * Header animated
     * @default false
     */
    animated?: boolean;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Translate prop
     */
    t?: any;
}

const getLogo = ({ invert, isMobile }: any) => {
    const type = isMobile ? 'mobile' : 'desktop';
    return invert ? Info.logos[type].invert : Info.logos[type].default;
};

const TheHeader: React.FC<TheHeaderProps> = ({ animated = false, className, style }) => {
    const { t } = useTranslation();
    const { y } = useScroll();
    const isMobile = useMediaQuery({ query: '(max-width: 992px)' });
    const [invert, setInvert] = useState(animated);
    const [logo, setLogo] = useState('');
    const classNames = classnames(['the-header', { animated: invert }, className]);

    useEffect(() => {
        setLogo(getLogo({ invert, isMobile }));
    }, [invert, isMobile]);
    useEffect(() => setInvert(animated && y <= 1), [animated, y]);

    return (
        <header className={classNames} style={style}>
            <div className="the-header__wrapper">
                {logo ? (
                    <>
                        <TheNav invert={invert} t={t} />
                        <div className="submenu-breadcrumb"></div>
                    </>
                ) : null}
            </div>
        </header>
    );
};

export default TheHeader;
